module.exports = __webpack_public_path__ + "img/clic.67ea63cb.png";